var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36332 4.14141C3.39332 3.86141 3.28332 3.58141 3.07332 3.39141L0.94332 0.821406V0.441406H7.57332L12.6933 11.6814L17.2033 0.441406H23.5233V0.821406L21.6933 2.57141C21.5333 2.69141 21.4533 2.89141 21.4933 3.08141V15.9514C21.4633 16.1514 21.5433 16.3414 21.6933 16.4614L23.4733 18.2114V18.5914H14.5133V18.2114L16.3633 16.4214C16.5433 16.2414 16.5433 16.1914 16.5433 15.9114V5.51141L11.4033 18.5514H10.7133L4.73332 5.51141V14.2514C4.68332 14.6214 4.80332 14.9914 5.06332 15.2514L7.46332 18.1614V18.5414H0.65332V18.1614L3.05332 15.2514C3.31332 14.9814 3.42332 14.6114 3.36332 14.2514V4.14141Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.87,
    height: 18.16,
    fill: "white",
    transform: "translate(0.65332 0.441406)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.7120c7d485a3cb70b7a54b306993c751.svg";
export { ForwardRef as ReactComponent };